import { useEffect, useState } from "react";
import { useClerk } from "@clerk/react";
import { CheckCircle2, GraduationCap, Loader2, LogOut, PenLine, Sparkles } from "lucide-react";
import { fetchClientMe } from "@/lib/bf";

export default function ClientHome() {
  const { signOut } = useClerk();
  const [d, setD] = useState(null);
  useEffect(() => { fetchClientMe().then(setD).catch(() => setD(false)); }, []);
  if (d === null) return <div className="st-loading"><Loader2 className="animate-spin" /> Se încarcă…</div>;
  return (
    <main className="bf-client-home" data-testid="client-home">
      <header><span className="st-brand-mark">Beauty <em>Trends</em></span>
        <button type="button" className="st-btn st-btn--ghost" onClick={() => signOut({ redirectUrl: "/sign-in" })} data-testid="client-logout"><LogOut size={14} /> Ieșire</button></header>
      <h1>Bun venit{d?.salon ? `, ${d.salon}` : ""}</h1>
      {d?.agent && <p className="st-hint" data-testid="client-agent">Agentul tău: {d.agent}</p>}
      <div className="bf-client-tiles">
        {d?.sign && <a className="bf-client-tile is-gold" href={d.sign} data-testid="client-sign"><PenLine size={22} /><b>Semnează contractul</b><span>Contractele cu firmele Beauty Trends te așteaptă</span></a>}
        {d?.signed && <div className="bf-client-tile" data-testid="client-signed"><CheckCircle2 size={22} /><b>Contract semnat</b><span>Mulțumim! Colaborarea este activă.</span></div>}
        <a className="bf-client-tile" href={d?.offers || "/blackfriday"} data-testid="client-offers"><Sparkles size={22} /><b>Branduri, oferte și prețuri</b><span>Medavita, Framesi, L'alga, Sono, Mowan și celelalte branduri</span></a>
        <div className="bf-client-tile is-soon" data-testid="client-edu"><GraduationCap size={22} /><b>Educație</b><span>Cursuri în România și internațional · în curând aici</span></div>
      </div>
    </main>
  );
}
